"use strict";
exports.__esModule = true;
var react_cookie_1 = require("react-cookie");
var CookieBanner_1 = require("./CookieBanner");
exports["default"] = react_cookie_1.withCookies(CookieBanner_1["default"]);



//////////////////
// WEBPACK FOOTER
// ./~/react-cookie-banner/lib/CookieBannerUniversal.js
// module id = 330
// module chunks = 35783957827783 114276838955818